export default __webpack_public_path__ + "static/media/CAPS.cc17a43b.svg";